<template>
    <div>
        <div id="map2" class="wrap-map" v-if="markers.length > 0"></div>
        <div class="text-center my-5" v-else>
            <h3>Sin resultados</h3>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            map: null,
            markers: [],
            center: {
                lat: -17.390366,
                lng: -66.153700
            },
        }
    },
    props: ['dateInit', 'dateEnd'],
    mounted() {
        this.getLocations()
    },
    methods: {
        // ubicaciones
        async getLocations() {
            await axios.get(`/admin/list-presales-delivery?date_init=${this.dateInit}&date_end=${this.dateEnd}`)
            .then((response) => {
                // console.log(response);
                if (response.data.length > 0) {
                    this.center.lat = +response.data[response.data.length-1].lat_map;
                    this.center.lng = +response.data[response.data.length-1].lng_map;
                    response.data.forEach(element => {
                        // console.log('/images/stores/'+element.photo);
                        this.markers.push({
                            lat: +element.lat_map,
                            lng: +element.lng_map,
                            label: `Pedido ${element.number}`
                        })
                    });
                    this.markers = this.markers.reverse();
                    setTimeout(() => {
                        this.initMap()
                    }, 1000);
                }
            })
            .catch((error) => {
                console.log(error);
            })
        },
        // list
        // ************/
        initMap() {
            // console.log(position.lat);
            this.map = new window.google.maps.Map(document.getElementById('map2'), {
                center: this.center,
                zoom: 12,
                disableDefaultUI: true,
                fullscreenControl: false,
                scaleControl: true,
                mapTypeId: 'roadmap',
                gestureHandling: "greedy"
            }) // Create the search box and link it to the UI element.

            // The markers for The Dakota and The Frick Collection
            this.setMarkers()
        },
        setMarkers() {
            var marker, i

            this.markers.forEach(element => {
                var latlngset = new window.google.maps.LatLng(element.lat, element.lng);
                marker = new window.google.maps.Marker({
                    position: latlngset,
                    // icon: `/images/store-marker.png`,
                    map: this.map
                });
                marker.addListener("click", () => {
                    this.map.setZoom(15);
                    this.map.setCenter(marker.getPosition());
                });

                /**
                 * info
                 */
                var content = `<div class="wrap-pin"><h4>${element.label}</h4></div>`
                var infowindow = new window.google.maps.InfoWindow()
                window.google.maps.event.addListener(marker, 'click', ((marker, content, infowindow) => {
                    return () => {
                        infowindow.setContent(content);
                        infowindow.open(this.map, marker);
                    };
                })(marker, content, infowindow));
                window.google.maps.event.addListener(this.map, 'click', () => {
                    infowindow.close();
                });
            });
        }
    },
}
</script>
<style lang="scss">
.wrap-map {
    @media (max-width: 600px) {
        height: 400px;
    }
    height: 600px;
}
.wrap-pin {
    display: flex;
    align-items: center;
    img {
        width: 100%;
        max-width: 200px;
        object-fit: cover;
        object-position: center;
        margin-right: 10px;
    }
}
</style>
